// import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { decodeHtml } from "../../components/util";

// import Brand from "../../components/Common/Brand";
import CounterStyleThree from "../../components/Elements/Counter/CounterStyleThree";
import ScrollToTop from "../../components/Common/ScrollTop";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const ServiceDetailsContent = () => {
  const { page } = useSelector((state) => state.data);
  const history = useHistory();

  const [htmlContent2, setHtmlContent2] = useState(null);
  const [htmlContent3, setHtmlContent3] = useState(null);

  useEffect(() => {
    if (page?.data) {
      const whyChooseUs = page.data["why-choose-us"];
      const serviceDescription = page.data["service-description"];

      if (whyChooseUs?.siteId === 2 && whyChooseUs.htmlContent) {
        const decodedHtml = decodeHtml(whyChooseUs.htmlContent);
        setHtmlContent2(decodedHtml);
      }

      if (serviceDescription?.siteId === 2 && serviceDescription.htmlContent) {
        const decodedHtml = decodeHtml(serviceDescription.htmlContent);
        // const cleanedHtml = decodedHtml.replace(/<\/?p[^>]*>/g, "");
        setHtmlContent3(decodedHtml);
        // setHtmlContent3(serviceDescription.htmlContent);
      }
    }
  }, [page]);

  return (
    <React.Fragment>
      <div
        onClick={(e) => {
          const link = e.target.closest("a.learn-more");
          if (link) {
            e.preventDefault();
            history.push("/contact");
            window.scrollTo(0, 0);
          }
        }}
        className="rs-about pt-120 pb-120 md-pt-80 md-pb-80"
      >
        {htmlContent3 ? (
          <div dangerouslySetInnerHTML={{ __html: htmlContent3 }} />
        ) : (
          <p>Loading Service Description...</p>
        )}
      </div>

      <div className="rs-about gray-bg pt-120 pb-120 md-pt-80 md-pb-60">
        {htmlContent2 ? (
          <div dangerouslySetInnerHTML={{ __html: htmlContent2 }} />
        ) : (
          <p>Loading Why Choose Us Content...</p>
        )}
      </div>

      <CounterStyleThree />

      {/* <Brand /> */}

      <ScrollToTop />
    </React.Fragment>
  );
};

export default ServiceDetailsContent;
